import { dateDifference } from 'lib/dateUtils'
import getTourV2VariationDuration from './getTourV2VariationDuration'

export interface TourV2PricePerDayDetails {
  pricePerDay: number | null
  isVariationLeading: boolean
  isDefaultPriceView: boolean
}

const PRICE_PER_DAY_VARIATION_ORIGIN = '0'
const PRICE_PER_DAY_VARIATION_LEADING = '1'

// eslint-disable-next-line no-prototype-builtins
const isOptionsForDeparture = (o: any): o is Tours.V2OfferDeparture => !!o.urgencyTags

export function extractTourV2PricePerDay(
  offer: Tours.V2Offer | Tours.V2OfferSummary,
  toursPricePerDayABTestVariation: string = PRICE_PER_DAY_VARIATION_ORIGIN,
  purchasableOption: Tours.V2OfferPurchasableOption,
  currencyCode: string,
  optionTypeDetail: Tours.V2OfferVariation | Tours.V2OfferDeparture,
): TourV2PricePerDayDetails {
  if (!offer.showPricePerDay || toursPricePerDayABTestVariation === PRICE_PER_DAY_VARIATION_ORIGIN || !purchasableOption) {
    return {
      isDefaultPriceView: true,
      isVariationLeading: false,
      pricePerDay: null,
    }
  }

  let daysCount: number
  if (isOptionsForDeparture(optionTypeDetail)) {
    daysCount = dateDifference(new Date(optionTypeDetail.endDate), new Date(optionTypeDetail.startDate))?.days + 1
  } else {
    daysCount = getTourV2VariationDuration(optionTypeDetail)
  }
  return {
    pricePerDay: purchasableOption.price / daysCount,
    isDefaultPriceView: false,
    isVariationLeading: (toursPricePerDayABTestVariation === PRICE_PER_DAY_VARIATION_LEADING),
  }
}
